import React from 'react'
import PropTypes from 'prop-types'
import includes from 'lodash/includes'
import css from './style.css'
import Modal from '../modal'
import Button from '../button'
import DiamondPhoto from '../diamond-photo'
import Spacer from '../spacer'
import Price from '../price'
import {
  displayDashIfNotExist,
  formatOrigin,
  formatGradingReport,
  formatRatio,
  formatDepth,
  formatTable,
  formatCrown,
  formatPavilion,
  formatSeparable,
  formatType,
  displayDecimal
} from '../../utils/format-diamond'
import ChevronLeftIcon from 'react-icons/lib/fa/chevron-left'
import ChevronRightIcon from 'react-icons/lib/fa/chevron-right'

class CompareModal extends Modal {
  render () {
    const props = this.props
    return (
      <Modal modalWidth={props.modalWidth < 9 ? 'width-' + props.modalWidth : 'width-9'} isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
        <div>
          <table className={css.compareTable}>
            <thead>
              <tr className={css.tableHead}>
                <th />
                {props.itemsToCompare.map((item, i) => {
                  const shouldDisplayLeftBtn = props.itemsToCompare.length > 0 && i > 0
                  const shouldDisplayRightBtn = props.itemsToCompare.length > 0 && i < props.itemsToCompare.length - 1
                  return (
                    <th className={css.itemHead} key={'th-' + i}>
                      {<DiamondPhoto compare firstImageURL={item['Image URL']} />}
                      <div className={css.titleSection}>
                        <span>Kimberfire<sup>&reg;</sup><br />#{item['Stock Number']}</span>
                        <div className={css.close} onClick={props.removeItem.bind(this, item, props.itemsToCompare)} />
                      </div>
                      <div className={css.clear} />
                      <Button compare disabled={!includes(props.addableDiamonds, item)} onClick={() => props.addDiamondClicked(item)}>Add Diamond</Button>
                      {(shouldDisplayLeftBtn || shouldDisplayRightBtn) && <Spacer />}
                      <div className={css.removeMargin}>
                        {shouldDisplayLeftBtn && <Button transparentBg onClick={() => props.swapCompareDataClicked(i, i - 1)}><i><ChevronLeftIcon /></i></Button>}
                        {shouldDisplayRightBtn && <Button transparentBg onClick={() => props.swapCompareDataClicked(i, i + 1)}><i><ChevronRightIcon /></i></Button>}
                      </div>
                      {!shouldDisplayLeftBtn && !shouldDisplayRightBtn && <Spacer xxs />}
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Price</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-price-' + i}><Price price={props.selectedDiamondPrices[i]} styleClass={css.price} noDecimal /></td>
                ))}
              </tr>
              <tr>
                <td>Shape</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-shape-' + i}>{displayDashIfNotExist(item['Shape'])}</td>
                ))}
              </tr>
              <tr>
                <td>Carat</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-carat-' + i}>{displayDecimal(item['Weight'])}</td>
                ))}
              </tr>
              <tr>
                <td>Colour</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-colour-' + i}>{displayDashIfNotExist(item['Color'] || item['Fancy Color'])}</td>
                ))}
              </tr>
              <tr>
                <td>Clarity</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-clarity-' + i}>{displayDashIfNotExist(item['Clarity'])}</td>
                ))}
              </tr>
              <tr>
                <td>Cut</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-cut-' + i}>{displayDashIfNotExist(item['Cut'])}</td>
                ))}
              </tr>
              <tr>
                <td>Polish</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-polish-' + i}>{displayDashIfNotExist(item['Polish'])}</td>
                ))}
              </tr>
              <tr>
                <td>Symmetry</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-symmetry-' + i}>{displayDashIfNotExist(item['Symmetry'])}</td>
                ))}
              </tr>
              <tr>
                <td>Fluorescence</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-fluorescence-' + i}>{displayDashIfNotExist(item['Fluorescence Intensity'])}</td>
                ))}
              </tr>
              <tr>
                <td>Depth</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-depth-' + i}>{formatDepth(item['Depth'])}</td>
                ))}
              </tr>
              <tr>
                <td>Table</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-table-' + i}>{formatTable(item['Table'])}</td>
                ))}
              </tr>
              <tr>
                <td>Crown</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-crown-' + i}>{formatCrown(item['Crown'], item['Crown Angle'], item['Crown Height'])}</td>
                ))}
              </tr>
              <tr>
                <td>Pavilion</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-pavilion-' + i}>{formatPavilion(item['Pavilion'], item['Pavilion Angle'], item['Pavilion Depth'])}</td>
                ))}
              </tr>
              <tr>
                <td>Length/Width</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-lw-' + i}>{formatRatio(item['Ratio'])}</td>
                ))}
              </tr>
              <tr>
                <td>Measurements</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-measurements-' + i}>{displayDashIfNotExist(item['Measurements'])}</td>
                ))}
              </tr>
              <tr>
                <td>Girdle</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-girdle-' + i}>{displayDashIfNotExist(item['Girdle'])}</td>
                ))}
              </tr>
              <tr>
                <td>Culet Size</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-culet-' + i}>{displayDashIfNotExist(item['Culet Size'])}</td>
                ))}
              </tr>
              <tr>
                <td>Origin</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-canadian-' + i}>{formatOrigin(item['Country of Origin'])}</td>
                ))}
              </tr>
              <tr>
                <td>Shade</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-shade-' + i}>{displayDashIfNotExist(item['Shade'])}</td>
                ))}
              </tr>
              <tr>
                <td>Treatment</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-treatment-' + i}>{displayDashIfNotExist(item['Treatment'])}</td>
                ))}
              </tr>
              <tr>
                <td>Inscription</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-inscription-' + i}>{displayDashIfNotExist(item['Laser Inscription'])}</td>
                ))}
              </tr>
              <tr>
                <td>Grading Report</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-report-' + i}>
                    {
                      item['Certificate URL'] ? <a href={item['Certificate URL']} target='_blank' rel='noreferrer'>{formatGradingReport(item['Lab'], item['Certificate Number'])}</a> : formatGradingReport(item['Lab'], item['Certificate Number'])
                    }
                  </td>
                ))}
              </tr>
              <tr>
                <td>Location</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-location-' + i}>{displayDashIfNotExist(item['Country'])}</td>
                ))}
              </tr>
              <tr>
                <td>Match</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-pairstock-' + i}>{displayDashIfNotExist(item['Pair Stock Number'])}</td>
                ))}
              </tr>
              <tr>
                <td>Separable?</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-is-separable-' + i}>{formatSeparable(item['Is Matched Pair'], item['Is Matched Pair Separable'])}</td>
                ))}
              </tr>
              <tr>
                <td>Seller</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-seller-' + i}>{displayDashIfNotExist(item['Name Code Secret'])}</td>
                ))}
              </tr>
              <tr>
                <td>Type</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-type-' + i}>{formatType(item['lg'])}</td>
                ))}
              </tr>
              <tr>
                <td>Report Comments</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-report-comments-' + i}>{displayDashIfNotExist(item['Cert Comments'])}</td>
                ))}
              </tr>
              <tr>
                <td>Additional Comments</td>
                {props.itemsToCompare.map((item, i) => (
                  <td key={'td-additional-comments-' + i}>{displayDashIfNotExist(item['Member Comments'])}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>
    )
  }
}

CompareModal.propTypes = {
  itemsToCompare: PropTypes.array.isRequired,
  modalWidth: PropTypes.number.isRequired,
  removeItem: PropTypes.func.isRequired,
  clearCompareButtonClicked: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  addDiamondClicked: PropTypes.func.isRequired,
  swapCompareDataClicked: PropTypes.func.isRequired
}

export default CompareModal



// WEBPACK FOOTER //
// ./src/components/compare-modal/index.js